import React from 'react';
import PageDetail from './PageDetail';

const DecorationDetail = (props) => {
  return <PageDetail tag='DECORATION' url='/decoration' id={props.match.params.id}/>;
}

export default DecorationDetail;